import { CARRIER_FIELD_LABELS } from './CarrierFieldLabels'

/**
 * Категорії файлів перевізника — рівно enum беку
 * `backend/web/src/Containers/CarrierContainer/Database/Enum/CarrierFileCategory.php`
 * (`SPEC-010` §5.3). Копію звіряє вартовий В-6
 * (`Ship/Helpers/architectureGuard.test.ts`, `ENUM_MIRRORS`).
 */
export const CARRIER_FILE_CATEGORIES = [
    'registration_document',
    'technical_passport',
    'cmr_insurance',
    'other',
] as const

export type CarrierFileCategory = (typeof CARRIER_FILE_CATEGORIES)[number]

/**
 * Крок 1 двокрокового завантаження (`SPEC-008` §5.7.1): сирота поточного
 * користувача. Категорія — в адресі, бо ядровий `FileInput` шле в тілі лише
 * `file` і `name` (Р10-1, `SPEC-010` §7.2).
 */
export const CARRIER_FILE_UPLOAD_URL = '/services/carrier_files'

/** Файлове поле картки ↔ категорія файлу. Порядок — як у легасі (`CarrierFormTemplate.jsx:100-103`). */
export const CARRIER_FILE_FIELDS = [
    { field: 'filesRegistrationDocuments', category: 'registration_document' },
    { field: 'filesTechnicalPassports', category: 'technical_passport' },
    { field: 'filesCmrInsurance', category: 'cmr_insurance' },
    { field: 'filesOther', category: 'other' },
] as const satisfies ReadonlyArray<{ field: keyof typeof CARRIER_FIELD_LABELS; category: CarrierFileCategory }>

export type CarrierFileField = (typeof CARRIER_FILE_FIELDS)[number]['field']

/** Імена чотирьох файлових полів — для `attachUploadedFiles` (Р10-4). */
export const CARRIER_FILE_FIELD_NAMES: readonly CarrierFileField[] = CARRIER_FILE_FIELDS.map(({ field }) => field)

/** Адреса завантаження поля: статичний рядок із `?category=…` (Р10-1). */
export const carrierFileUploadUrl = (category: CarrierFileCategory): string =>
    `${CARRIER_FILE_UPLOAD_URL}?category=${category}`

/**
 * Підпис категорії в журналі змін — той самий, що підпис поля в картці
 * (`SPEC-010` §12): «Реєстраційний документ», «Технічний паспорт»,
 * «CMR страхування», «Інше».
 */
export const CARRIER_FILE_CATEGORY_LABELS: Record<CarrierFileCategory, string> = Object.fromEntries(
    CARRIER_FILE_FIELDS.map(({ field, category }) => [category, CARRIER_FIELD_LABELS[field]])
) as Record<CarrierFileCategory, string>
